import { render, staticRenderFns } from "./FanCharacteristics.vue?vue&type=template&id=43831a74&scoped=true&"
import script from "./FanCharacteristics.vue?vue&type=script&lang=js&"
export * from "./FanCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./FanCharacteristics.vue?vue&type=style&index=0&id=43831a74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43831a74",
  null
  
)

export default component.exports